<template>
  <b-card id="bench-card" :class="{ empty: !score }">
    <header slot="header" class="title2">
      {{ title }}
    </header>
    <div class="body">
      <div class="rank-head">
        <div>
          <p
            class="huge-metric"
            :style="'color :' + color"
            v-if="score !== null"
          >
            {{ round(score) }}
          </p>
          <p class="huge-metric" v-else>-</p>
          <p>{{ benchmarkResources.card.company }}</p>
        </div>
        <div class="badge">
          <img
            :alt="benchmarkResources.badges[this.badge]"
            :src="geBadgeImageUrl(score)"
          />
          <p>{{ benchmarkResources.badges[this.badge] }}</p>
        </div>
        <div>
          <p class="huge-metric">{{ round(average) }}</p>
          <p>{{ benchmarkResources.card.market }}</p>
        </div>
      </div>
      <div class="rank-bar">
        <b-progress :max="100">
          <div
            v-if="score !== null"
            class="vertical-line"
            :style="'left: ' + percentRank + '%'"
          ></div>
          <b-progress-bar :value="25" variant="danger"></b-progress-bar>
          <b-progress-bar :value="50" variant="warning"></b-progress-bar>
          <b-progress-bar :value="25" variant="success"></b-progress-bar>
        </b-progress>
      </div>
      <p class="rank-msg" v-if="score !== null">
        {{ benchmarkResources.card.rankMsgA }} {{ percentRank }}%
        {{ benchmarkResources.card.rankMsgB }}
      </p>
      <p class="rank-msg locked" v-else>
        {{ benchmarkResources.card.lockedA }} {{ title }}
        {{ benchmarkResources.card.lockedB }}
      </p>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BenchScoreCard',
  props: {
    title: {
      required: true,
      type: String,
    },
    score: {
      required: false,
      type: Number,
    },
    average: {
      required: false,
      type: Number,
    },
    percentRank: {
      required: false,
      type: Number,
      default: 25,
    },
    base: {
      required: false,
      type: String,
      default: '0-10',
    },
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    badge() {
      if (!this.percentRank) return null
      if (this.percentRank < 55) return 'bronze'
      if (this.percentRank < 65) return 'silver'
      if (this.percentRank < 75) return 'gold'
      if (this.percentRank < 85) return 'platinum'
      if (this.percentRank < 95) return 'diamond'
      return 'champion'
    },
    benchmarkResources() {
      return this.resources.page.reports.benchmark
    },
    color() {
      if (!this.percentRank) return null
      if (this.percentRank < 25) return '#dc3545'
      if (this.percentRank < 75) return '#fcc108'
      return '#28a745'
    },
  },
  methods: {
    round(number) {
      return this.base === '0|10' ? number : Math.round(number)
    },
    geBadgeImageUrl() {
      if (!this.badge) return null
      return `badges/${this.badge}.png`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

#bench-card {
  border-radius: 8px;
  margin-bottom: 20px;
  width: 48%;
}
.empty {
  background: #f6f6f6;
  .card-header {
    background: #f6f6f6;
  }
}
header {
  color: #292929;
  font-size: 25px;
  font-weight: normal;
}
p {
  color: #8b8b8b;
}
.card-body {
  padding: 20px 0 0 0;
  width: 90%;
  margin: auto;
}
.rank-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  div {
    width: 100%;
    text-align: center;
  }
  .huge-metric {
    margin: 0;
    font-size: 55px;
    font-weight: 600;
    color: #292929;
  }
  .badge {
    img {
      max-width: 116px;
    }
    p {
      color: #000000;
      font-weight: 600;
      font-size: 1rem;
    }
  }
}
.rank-bar {
  position: relative;
  .progress {
    height: 20px;
    border-radius: 28px;
    border: 1.2px solid #c6c6c6;
    box-shadow: 0px 5px 3px rgba(61, 90, 254, 0.1);
    .vertical-line {
      content: '';
      width: 1px;
      height: 40px;
      position: absolute;
      border: 1px solid black;
      border-style: dashed;
      z-index: 1000;
      bottom: -10px;
    }
  }
}
.rank-msg {
  text-align: center;
  margin: 20px 0 5px 0;
  &.locked {
    color: orangered;
  }
}

@include media-breakpoint-down(lg) {
  header {
    font-size: 20px;
  }
  .rank-head {
    .huge-metric {
      font-size: 40px;
    }
    .badge {
      img {
        max-width: 80px;
      }
    }
  }
}

@include media-breakpoint-down(md) {
  #bench-card {
    width: 100%;
  }
  .rank-head {
    .huge-metric {
      font-size: 70px;
    }
    .badge {
      img {
        max-width: 160px;
      }
    }
  }
}

@include media-breakpoint-down(sm) {
  .rank-head {
    .huge-metric {
      font-size: 40px;
    }
    .badge {
      img {
        max-width: 80px;
      }
    }
  }
}
</style>
